import React, { useState } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import { Button } from 'antd';
import MapAutoComplete from 'components/Map/MapAutoComplete';
import useCities from 'library/hooks/useCities';
import { setStateToUrl } from 'library/helpers/url_handler';
import { LISTING_POSTS_PAGE } from 'settings/constant';
import { ComponentWrapper, FormWrapper } from './Header.style';

export default function NavbarSearch() {
  let navigate = useNavigate();
  const { cities } = useCities();

  const [citySelected, setCitySelected] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);

  const updateValueFunc = (value) => {
    setSelectedCity(value.searchedLocation);
    setCitySelected(!!value.searchedLocation);
  };

  const goToSearchPage = () => {
    const formatCityForUrl = (city) => {
      return `${city.name.replaceAll(' ', '_')}~${city.country.replaceAll(' ', '_') || ''}`;
    };

    const query = {
      city: selectedCity ? encodeURIComponent(formatCityForUrl(selectedCity)) : '',
    };
    const search = setStateToUrl(query);
    navigate({
      pathname: LISTING_POSTS_PAGE,
      search: `?${createSearchParams(search)}`,
    });
    window.location.reload();
  };

  return (
    <FormWrapper>
      <ComponentWrapper>
        <MapAutoComplete updateValue={(value) => updateValueFunc(value)}
        onSearchTrigger={goToSearchPage} cities={cities} />
      </ComponentWrapper>
      <Button
        type="primary"
        htmlType="submit"
        size="small"
        onClick={goToSearchPage}
        disabled={!citySelected}
        style={{
          cursor: !citySelected ? 'not-allowed' : 'pointer',
          borderRadius: '2px',
          padding: '7px',
        }}
        title={!citySelected ? 'Select city from dropdown' : ''}
      >
        <FiSearch />
      </Button>
    </FormWrapper>
  );
}
